
<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import { Radar } from 'vue-chartjs'

export default {
  name: 'RadarChartMobile',
  extends: Radar,
  props: [],

  data () {
    return {
      scoresPercent: [],
      categoriesList: [],
      computedScores: []
    }
  },

  methods: {
    ...mapActions('survey', {
      getSurveyFromID: 'getSurveyFromID',
    }),

    drawChart(labelArray, dataArray, sectionColors) {
      this.renderChart({
      labels: labelArray,
      datasets: [
        {
          label: 'Performance',
          backgroundColor: '#00f0afaa',
          data: dataArray,
          lineTension: 0.05,
          pointBackgroundColor: '#00f0af',
          borderWidth: 2
        },
        { // this transparent data allows to go from 0 to 100 in the chart
          label: 'Data One',
          backgroundColor: '#FFFFFF00',
          data: [110,0],
          lineTension: 0,
          pointBackgroundColor: '#FFFFFF00',
          borderWidth: 0,
          pointRadius: 0,
          borderWidth: 0,
          pointHitRadius: 0
        }
      ]
    }, {
      responsive: true,
      legend: {
        display: false,
        fontColor: '#F00',
        fontSize: 22
      },
      scale: {
          reverse: false,
          ticks: {
              display: false,
              max: 11, // notice how this is +1 more than what you actually want
          },
          gridLines: {
            color: [
        "#dddddd", "#dddddd", "#dddddd", "#dddddd", "#dddddd",
        "transparent" ]
          },
          ticks: {
            beginAtZero: true,
            max: 100,
            min: 0,
            stepSize: 20,
            color: sectionColors
          },
          pointLabels: {
            fontSize: 12,
            fontColor: sectionColors,
            fontFamily: "Nunito",
          },
          angleLines: {
              display: true,
              color: "transparent",
          },
        },
      maintainAspectRatio: false,

    })
    }
  },

  computed: {
    ...mapGetters({
      profile: 'lead/profile',
      survey: 'survey/survey',
      surveyID: 'survey/docID',
      surveyCategories: 'survey/categories'
    }),
  },

  async created() {

    // get the quiz using the id passed in url params
    if (this.$route.params.id !== undefined){
      var payload = {docID: this.$route.params.id};
    }
    else {
      var payload = {docID: this.surveyID};
    }
    await this.getSurveyFromID(payload);

    var surveyColors = [];

    for (let category of this.surveyCategories) {
      var percent = 100 * parseInt(category.userScore) / parseInt(category.maxScore);
      var catName = this.$options.filters.translategrader(category.name, this.$i18n.locale)
      var catNameSplit = catName.split(" ");
      if (typeof catNameSplit === "string") {
        this.categoriesList.push([catName]);
      } else {
        this.categoriesList.push(catNameSplit);
      }

      this.computedScores.push(percent);
      // Get colors
      surveyColors.push(category.color);
    }

    console.log("Radarchart: ", this.categoriesList);

    // Generate chart (onlyduring 'created' step)
    this.drawChart(this.categoriesList, this.computedScores, surveyColors);

  },


}
</script>

<style scoped>

.chartjs-size-monitor, .chartjs-render-monitor {
  font-size: 8px!important;
  line-break: 7px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/RadarChartMobile.vue